import styled from 'styled-components';

export const ContractIdEditorHostContainer = styled.div`
  > [role='dialog'] > div {
    gap: 0;
    padding: 0;
  }

  > [role='dialog'] > div > header {
    align-self: stretch;
    box-sizing: border-box;
    padding-left: 30px;
    padding-right: 30px;
  }

  > [role='dialog'] > div > section[aria-label='Contract ID search'] {
    padding-left: 30px;
  }

  .selectedItem > div {
    padding: 0;
    border: none;
    background: transparent;
  }

  .selectedItem [class*='control'] {
    width: 80px;
    height: 40px;
    border: 1px solid #b3babc !important;
    border-radius: 2px;
    background: #fff;
  }

  .selectedItem [class*='singleValue'] {
    max-width: none;
    overflow: visible;
    white-space: nowrap;
  }
`;
